/**
 * Bryant Park bounding box (axis-aligned rectangle from provided corners).
 * Lat/lng in decimal degrees.
 */
export const PARK_BOUNDS = {
  latMin: 40.75191051241469,
  latMax: 40.75512899555782,
  lngMin: -73.98594539103877,
  lngMax: -73.9805165181125
};

/**
 * Returns true if the given point (lat, lng) is inside the park bounding box.
 * @param {number} lat - Latitude in decimal degrees
 * @param {number} lng - Longitude in decimal degrees
 * @returns {boolean}
 */
export function isInsideParkBounds(lat, lng) {
  if (lat == null || lng == null) return false;
  const { latMin, latMax, lngMin, lngMax } = PARK_BOUNDS;
  return lat >= latMin && lat <= latMax && lng >= lngMin && lng <= lngMax;
}
